export default "__VITE_ASSET__B7Rv1F1k__"